<!-- weekly-enrollment-sales-tracking-report.component.html -->
<div class="container-fluid">
  <!-- Page Header with Utility Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Weekly Sales Tracking Report</h1><!-- Weekly Enrollment & Sales Tracking Report -->

    <!-- Utility Buttons -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <div class="d-flex flex-wrap gap-1">
        <button
          style="color:#fff; background-color: #0AC92B !important; border-color: #0AC92B !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="exportToCsv()">
          <mat-icon>file_download</mat-icon>
          <span>Export to CSV</span>
        </button>
        <button style="background-color: transparent !important; border: none;"
          (click)="onPrint()"
          type="button"
          mat-icon-button
          class="me-1 mb-1"
          matTooltip="Print weekly enrollment sales tracking report"
          matTooltipPosition="below"
          aria-label="Print weekly enrollment sales tracking report">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>
      </div>
    </div>
  </div>

	<div class="container-fluid">

		<mat-expansion-panel expanded="true">
			<mat-expansion-panel-header>
				<mat-panel-title>Filter</mat-panel-title>
			</mat-expansion-panel-header>
			<form #f="ngForm" class="form">
				<div class="row">
					<app-week-year-selector
						[showDateRange]="true"
						[initialWeek]="week"
						[initialYear]="year"
						[initialDateRange]="dateTimeRange"
						[showNoneOption]="false"
						dateRangeColClass="col-12 col-md-6 col-lg"
						weekColClass="col-12 col-sm-6 col-lg"
						yearColClass="col-12 col-sm-6 col-lg"
						(selectionChange)="onWeekYearChange($event)">
					</app-week-year-selector>
				</div>

				<div class="row">
					<section class="section">
						<div class="float-end">
							<button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear</button>
						</div>
					</section>
				</div>
			</form>
		</mat-expansion-panel>


		<mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>
	</div>

  <div class="container-fluid">

		<!-- Inquiries Table -->
		<h2>Inquiries ({{ inquiriesData?.length || 0 }})</h2>
		<table mat-table [dataSource]="inquiriesData" class="mat-elevation-z8 mat-table">
			<ng-container matColumnDef="name">
				<th mat-header-cell *matHeaderCellDef> Name </th>
				<td mat-cell *matCellDef="let row"> {{ row.name }} </td>
			</ng-container>
			<ng-container matColumnDef="callDates">
				<th mat-header-cell *matHeaderCellDef> Contact Date{{ inquiryTotals ? ' (' + inquiryTotals.contacts + ')' : '' }} </th>
				<td mat-cell *matCellDef="let row"> {{ row.callDates }} </td>
			</ng-container>
			<ng-container matColumnDef="bookingDates">
				<th mat-header-cell *matHeaderCellDef> Booking Date{{ inquiryTotals ? ' (' + inquiryTotals.booked + ')' : '' }} </th>
				<td mat-cell *matCellDef="let row"> {{ row.bookingDates }} </td>
			</ng-container>
			<ng-container matColumnDef="showedDates">
				<th mat-header-cell *matHeaderCellDef> Showed Date{{ inquiryTotals ? ' (' + inquiryTotals.showed + ')' : '' }} </th>
				<td mat-cell *matCellDef="let row"> {{ row.showedDates }} </td>
			</ng-container>
			<ng-container matColumnDef="executive">
				<th mat-header-cell *matHeaderCellDef> Executive </th>
				<td mat-cell *matCellDef="let row"> {{ row.executive }} </td>
			</ng-container>
			<ng-container matColumnDef="teacher">
				<th mat-header-cell *matHeaderCellDef> Teacher </th>
				<td mat-cell *matCellDef="let row"> {{ row.teacher }} </td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="['name', 'callDates', 'bookingDates', 'showedDates', 'executive', 'teacher']"></tr>
			<tr mat-row *matRowDef="let row; columns: ['name', 'callDates', 'bookingDates', 'showedDates', 'executive', 'teacher']"></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell" colspan="6">
					<ng-container *ngIf="!ShowProgressBar">No inquiries found for this period</ng-container>
				</td>
			</tr>
		</table>

	</div>

  <!-- Data Tables -->
  <div class="container-fluid">
    <!-- DE Enrollments Table -->
    <div *ngIf="deEnrollmentsData?.length > 0">
      <h2>DE Enrollments ({{ deEnrollmentsData?.length || 0 }})</h2>
      <table mat-table [dataSource]="deEnrollmentsData" class="mat-elevation-z8 mat-table">
        <!-- Student Name Column -->
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef>Student Name</th>
          <td mat-cell *matCellDef="let row">{{ row.student_name }}</td>
        </ng-container>
        <!-- Package Name Column -->
        <ng-container matColumnDef="packageName">
          <th mat-header-cell *matHeaderCellDef>Package</th>
          <td mat-cell *matCellDef="let row">{{ row.package_name }}</td>
        </ng-container>
        <!-- Date Enrolled Column -->
        <ng-container matColumnDef="dateEnrolled">
          <th mat-header-cell *matHeaderCellDef>Date Enrolled</th>
          <td mat-cell *matCellDef="let row">{{ reportDateService.formatDate(row.date_enrolled) }}</td>
        </ng-container>
        <!-- Lessons Enrolled Column -->
        <ng-container matColumnDef="lessonsEnrolled">
          <th mat-header-cell *matHeaderCellDef># of Lessons</th>
          <td mat-cell *matCellDef="let row">{{ row.lessons_enrolled }}</td>
        </ng-container>
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="text-end">Amount ($)</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.amount | studioCurrency }}</td>
        </ng-container>
        <!-- Teachers Column -->
        <ng-container matColumnDef="teachers">
          <th mat-header-cell *matHeaderCellDef>Teachers</th>
          <td mat-cell *matCellDef="let row">{{ row.teachers }}</td>
        </ng-container>
        <!-- Outcome Column -->
        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef><span class="text-nowrap" matTooltip="Shows the next enrollment the student purchased after this one, with its purchase date. No Sale means the enrollment finished (all lessons paid and taken) with no later purchase, matching the Sale/No Sale report. Blank means the enrollment is still open.">Outcome <mat-icon class="help-icon-inline">help_outline</mat-icon></span></th>
          <td mat-cell *matCellDef="let row">{{ formatOutcome(row.outcome) }}</td>
        </ng-container>

        <!-- Table Headers and Rows -->
        <tr mat-header-row *matHeaderRowDef="['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']" [class.bg-success-subtle]="isPurchasedOutcome(row.outcome)"></tr>
      </table>
    </div>

    <!-- Pre Enrollments Table -->
    <div *ngIf="preEnrollmentsData?.length > 0">
      <h2>Pre Enrollments ({{ preEnrollmentsData?.length || 0 }})</h2>
      <table mat-table [dataSource]="preEnrollmentsData" class="mat-elevation-z8 mat-table">
        <!-- Student Name Column -->
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef>Student Name</th>
          <td mat-cell *matCellDef="let row">{{ row.student_name }}</td>
        </ng-container>
        <!-- Package Name Column -->
        <ng-container matColumnDef="packageName">
          <th mat-header-cell *matHeaderCellDef>Package</th>
          <td mat-cell *matCellDef="let row">{{ row.package_name }}</td>
        </ng-container>
        <!-- Date Enrolled Column -->
        <ng-container matColumnDef="dateEnrolled">
          <th mat-header-cell *matHeaderCellDef>Date Enrolled</th>
          <td mat-cell *matCellDef="let row">{{ reportDateService.formatDate(row.date_enrolled) }}</td>
        </ng-container>
        <!-- Lessons Enrolled Column -->
        <ng-container matColumnDef="lessonsEnrolled">
          <th mat-header-cell *matHeaderCellDef># of Lessons</th>
          <td mat-cell *matCellDef="let row">{{ row.lessons_enrolled }}</td>
        </ng-container>
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="text-end">Amount ($)</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.amount | studioCurrency }}</td>
        </ng-container>
        <!-- Teachers Column -->
        <ng-container matColumnDef="teachers">
          <th mat-header-cell *matHeaderCellDef>Teachers</th>
          <td mat-cell *matCellDef="let row">{{ row.teachers }}</td>
        </ng-container>
        <!-- Outcome Column -->
        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef><span class="text-nowrap" matTooltip="Shows the next enrollment the student purchased after this one, with its purchase date. No Sale means the enrollment finished (all lessons paid and taken) with no later purchase, matching the Sale/No Sale report. Blank means the enrollment is still open.">Outcome <mat-icon class="help-icon-inline">help_outline</mat-icon></span></th>
          <td mat-cell *matCellDef="let row">{{ formatOutcome(row.outcome) }}</td>
        </ng-container>

        <!-- Table Headers and Rows -->
        <tr mat-header-row *matHeaderRowDef="['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']" [class.bg-success-subtle]="isPurchasedOutcome(row.outcome)"></tr>
      </table>
    </div>

    <!-- ORIs Table -->
    <div *ngIf="oriData?.length > 0">
      <h2>ORIs ({{ oriData?.length || 0 }})</h2>
      <table mat-table [dataSource]="oriData" class="mat-elevation-z8 mat-table">
        <!-- Student Name Column -->
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef>Student Name</th>
          <td mat-cell *matCellDef="let row">{{ row.student_name }}</td>
        </ng-container>
        <!-- Package Name Column -->
        <ng-container matColumnDef="packageName">
          <th mat-header-cell *matHeaderCellDef>Package</th>
          <td mat-cell *matCellDef="let row">{{ row.package_name }}</td>
        </ng-container>
        <!-- Date Enrolled Column -->
        <ng-container matColumnDef="dateEnrolled">
          <th mat-header-cell *matHeaderCellDef>Date Enrolled</th>
          <td mat-cell *matCellDef="let row">{{ reportDateService.formatDate(row.date_enrolled) }}</td>
        </ng-container>
        <!-- Lessons Enrolled Column -->
        <ng-container matColumnDef="lessonsEnrolled">
          <th mat-header-cell *matHeaderCellDef># of Lessons</th>
          <td mat-cell *matCellDef="let row">{{ row.lessons_enrolled }}</td>
        </ng-container>
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="text-end">Amount ($)</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.amount | studioCurrency }}</td>
        </ng-container>
        <!-- Teachers Column -->
        <ng-container matColumnDef="teachers">
          <th mat-header-cell *matHeaderCellDef>Teachers</th>
          <td mat-cell *matCellDef="let row">{{ row.teachers }}</td>
        </ng-container>
        <!-- Outcome Column -->
        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef><span class="text-nowrap" matTooltip="Shows the next enrollment the student purchased after this one, with its purchase date. No Sale means the enrollment finished (all lessons paid and taken) with no later purchase, matching the Sale/No Sale report. Blank means the enrollment is still open.">Outcome <mat-icon class="help-icon-inline">help_outline</mat-icon></span></th>
          <td mat-cell *matCellDef="let row">{{ formatOutcome(row.outcome) }}</td>
        </ng-container>

        <!-- Table Headers and Rows -->
        <tr mat-header-row *matHeaderRowDef="['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']" [class.bg-success-subtle]="isPurchasedOutcome(row.outcome)"></tr>
      </table>
    </div>

    <!-- EXTs Table -->
    <div *ngIf="extData?.length > 0">
      <h2>EXTs ({{ extData?.length || 0 }})</h2>
      <table mat-table [dataSource]="extData" class="mat-elevation-z8 mat-table">
        <!-- Student Name Column -->
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef>Student Name</th>
          <td mat-cell *matCellDef="let row">{{ row.student_name }}</td>
        </ng-container>
        <!-- Package Name Column -->
        <ng-container matColumnDef="packageName">
          <th mat-header-cell *matHeaderCellDef>Package</th>
          <td mat-cell *matCellDef="let row">{{ row.package_name }}</td>
        </ng-container>
        <!-- Date Enrolled Column -->
        <ng-container matColumnDef="dateEnrolled">
          <th mat-header-cell *matHeaderCellDef>Date Enrolled</th>
          <td mat-cell *matCellDef="let row">{{ reportDateService.formatDate(row.date_enrolled) }}</td>
        </ng-container>
        <!-- Lessons Enrolled Column -->
        <ng-container matColumnDef="lessonsEnrolled">
          <th mat-header-cell *matHeaderCellDef># of Lessons</th>
          <td mat-cell *matCellDef="let row">{{ row.lessons_enrolled }}</td>
        </ng-container>
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="text-end">Amount ($)</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.amount | studioCurrency }}</td>
        </ng-container>
        <!-- Teachers Column -->
        <ng-container matColumnDef="teachers">
          <th mat-header-cell *matHeaderCellDef>Teachers</th>
          <td mat-cell *matCellDef="let row">{{ row.teachers }}</td>
        </ng-container>
        <!-- Outcome Column -->
        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef><span class="text-nowrap" matTooltip="Shows the next enrollment the student purchased after this one, with its purchase date. No Sale means the enrollment finished (all lessons paid and taken) with no later purchase, matching the Sale/No Sale report. Blank means the enrollment is still open.">Outcome <mat-icon class="help-icon-inline">help_outline</mat-icon></span></th>
          <td mat-cell *matCellDef="let row">{{ formatOutcome(row.outcome) }}</td>
        </ng-container>

        <!-- Table Headers and Rows -->
        <tr mat-header-row *matHeaderRowDef="['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']" [class.bg-success-subtle]="isPurchasedOutcome(row.outcome)"></tr>
      </table>
    </div>

    <!-- RENs Table -->
    <div *ngIf="renData?.length > 0">
      <h2>RENs ({{ renData?.length || 0 }})</h2>
      <table mat-table [dataSource]="renData" class="mat-elevation-z8 mat-table">
        <!-- Student Name Column -->
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef>Student Name</th>
          <td mat-cell *matCellDef="let row">{{ row.student_name }}</td>
        </ng-container>
        <!-- Package Name Column -->
        <ng-container matColumnDef="packageName">
          <th mat-header-cell *matHeaderCellDef>Package</th>
          <td mat-cell *matCellDef="let row">{{ row.package_name }}</td>
        </ng-container>
        <!-- Date Enrolled Column -->
        <ng-container matColumnDef="dateEnrolled">
          <th mat-header-cell *matHeaderCellDef>Date Enrolled</th>
          <td mat-cell *matCellDef="let row">{{ reportDateService.formatDate(row.date_enrolled) }}</td>
        </ng-container>
        <!-- Lessons Enrolled Column -->
        <ng-container matColumnDef="lessonsEnrolled">
          <th mat-header-cell *matHeaderCellDef># of Lessons</th>
          <td mat-cell *matCellDef="let row">{{ row.lessons_enrolled }}</td>
        </ng-container>
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="text-end">Amount ($)</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.amount | studioCurrency }}</td>
        </ng-container>
        <!-- Teachers Column -->
        <ng-container matColumnDef="teachers">
          <th mat-header-cell *matHeaderCellDef>Teachers</th>
          <td mat-cell *matCellDef="let row">{{ row.teachers }}</td>
        </ng-container>
        <!-- Outcome Column -->
        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef><span class="text-nowrap" matTooltip="Shows the next enrollment the student purchased after this one, with its purchase date. No Sale means the enrollment finished (all lessons paid and taken) with no later purchase, matching the Sale/No Sale report. Blank means the enrollment is still open.">Outcome <mat-icon class="help-icon-inline">help_outline</mat-icon></span></th>
          <td mat-cell *matCellDef="let row">{{ formatOutcome(row.outcome) }}</td>
        </ng-container>

        <!-- Table Headers and Rows -->
        <tr mat-header-row *matHeaderRowDef="['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']" [class.bg-success-subtle]="isPurchasedOutcome(row.outcome)"></tr>
      </table>
    </div>

    <!-- Non-Unit Sales Table -->
    <div *ngIf="nonUnitSalesData?.length > 0">
      <h2>Non-Unit Sales ({{ nonUnitSalesData?.length || 0 }})</h2>
      <table mat-table [dataSource]="nonUnitSalesData" class="mat-elevation-z8 mat-table">
        <!-- Student Name Column -->
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef>Student Name</th>
          <td mat-cell *matCellDef="let row">{{ row.student_name }}</td>
        </ng-container>
        <!-- Package Name Column -->
        <ng-container matColumnDef="packageName">
          <th mat-header-cell *matHeaderCellDef>Package</th>
          <td mat-cell *matCellDef="let row">{{ row.package_name }}</td>
        </ng-container>
        <!-- Date Enrolled Column -->
        <ng-container matColumnDef="dateEnrolled">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let row">{{ reportDateService.formatDate(row.date_enrolled) }}</td>
        </ng-container>
        <!-- Quantity Column -->
        <ng-container matColumnDef="lessonsEnrolled">
          <th mat-header-cell *matHeaderCellDef>Quantity</th>
          <td mat-cell *matCellDef="let row">{{ row.lessons_enrolled }}</td>
        </ng-container>
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="text-end">Amount ($)</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.amount | studioCurrency }}</td>
        </ng-container>
        <!-- Teachers Column -->
        <ng-container matColumnDef="teachers">
          <th mat-header-cell *matHeaderCellDef>Teachers</th>
          <td mat-cell *matCellDef="let row">{{ row.teachers }}</td>
        </ng-container>
        <!-- Outcome Column -->
        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef><span class="text-nowrap" matTooltip="Shows the next enrollment the student purchased after this one, with its purchase date. No Sale means the enrollment finished (all lessons paid and taken) with no later purchase, matching the Sale/No Sale report. Blank means the enrollment is still open.">Outcome <mat-icon class="help-icon-inline">help_outline</mat-icon></span></th>
          <td mat-cell *matCellDef="let row">{{ formatOutcome(row.outcome) }}</td>
        </ng-container>

        <!-- Table Headers and Rows -->
        <tr mat-header-row *matHeaderRowDef="['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']" [class.bg-success-subtle]="isPurchasedOutcome(row.outcome)"></tr>
      </table>
    </div>

    <!-- Miscellaneous Sales Table -->
    <div *ngIf="miscSalesData?.length > 0">
      <h2>Miscellaneous Sales ({{ miscSalesData?.length || 0 }})</h2>
      <table mat-table [dataSource]="miscSalesData" class="mat-elevation-z8 mat-table">
        <!-- Student Name Column -->
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef>Customer Name</th>
          <td mat-cell *matCellDef="let row">{{ row.student_name }}</td>
        </ng-container>
        <!-- Package Name Column -->
        <ng-container matColumnDef="packageName">
          <th mat-header-cell *matHeaderCellDef>Package</th>
          <td mat-cell *matCellDef="let row">{{ row.package_name }}</td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="dateEnrolled">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let row">{{ reportDateService.formatDate(row.date_enrolled) }}</td>
        </ng-container>
        <!-- Quantity Column -->
        <ng-container matColumnDef="lessonsEnrolled">
          <th mat-header-cell *matHeaderCellDef>Quantity</th>
          <td mat-cell *matCellDef="let row">{{ row.lessons_enrolled }}</td>
        </ng-container>
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="text-end">Amount ($)</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.amount | studioCurrency }}</td>
        </ng-container>
        <!-- Teachers Column -->
        <ng-container matColumnDef="teachers">
          <th mat-header-cell *matHeaderCellDef>Teachers</th>
          <td mat-cell *matCellDef="let row">{{ row.teachers }}</td>
        </ng-container>
        <!-- Outcome Column -->
        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef><span class="text-nowrap" matTooltip="Shows the next enrollment the student purchased after this one, with its purchase date. No Sale means the enrollment finished (all lessons paid and taken) with no later purchase, matching the Sale/No Sale report. Blank means the enrollment is still open.">Outcome <mat-icon class="help-icon-inline">help_outline</mat-icon></span></th>
          <td mat-cell *matCellDef="let row">{{ formatOutcome(row.outcome) }}</td>
        </ng-container>

        <!-- Table Headers and Rows -->
        <tr mat-header-row *matHeaderRowDef="['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['studentName', 'packageName', 'dateEnrolled', 'lessonsEnrolled', 'amount', 'teachers', 'outcome']" [class.bg-success-subtle]="isPurchasedOutcome(row.outcome)"></tr>
      </table>
    </div>

	</div>

	<!-- Spacing for the bottom of the page -->
	<div class="mt-4" style="height: 100px;"></div>

</div>
